import { SVGProps, Ref, forwardRef } from 'react';

export const SquaresIntersectedOutlinedSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.038 17H8c-7 0-8-1-8-8s1-8 8-8c6.27 0 7.726.802 7.962 6h.037c7 0 8 1 8 8s-1 8-8 8c-6.27 0-7.726-.802-7.961-6M1.8 9c0-1.736.065-2.968.234-3.87.167-.884.403-1.272.614-1.482s.598-.447 1.482-.614C5.032 2.865 6.264 2.8 8 2.8s2.968.065 3.87.235c.884.166 1.272.402 1.482.613s.447.598.614 1.482c.097.515.16 1.138.195 1.901C8.818 7.244 8 8.666 8 15v.2c-1.736 0-2.968-.065-3.87-.234-.884-.167-1.272-.403-1.482-.614s-.447-.598-.614-1.482C1.865 11.968 1.8 10.736 1.8 9M16 8.8c1.736 0 2.968.065 3.87.234.884.167 1.271.403 1.482.614.21.21.446.598.613 1.482.17.902.235 2.134.235 3.87s-.065 2.968-.235 3.87c-.167.884-.403 1.272-.613 1.482s-.598.447-1.483.613c-.901.17-2.133.235-3.87.235-1.736 0-2.968-.065-3.87-.235-.884-.166-1.271-.402-1.482-.613-.21-.21-.446-.598-.613-1.482-.097-.515-.16-1.138-.196-1.901C15.181 16.756 16 15.334 16 9zm-1.8.031V9c0 1.736-.065 2.968-.234 3.87-.167.884-.403 1.272-.614 1.482s-.598.447-1.482.614c-.553.104-1.23.168-2.07.203V15c0-1.736.064-2.968.234-3.87.167-.884.403-1.272.613-1.482s.598-.447 1.483-.614c.552-.104 1.229-.168 2.07-.203"
                fill="currentColor"
            />
        </svg>
    )
);
SquaresIntersectedOutlinedSize24Glyph.displayName = 'SquaresIntersectedOutlinedSize24Glyph';
